import Vue from 'vue'
import VueRouter from 'vue-router'
import firebase from 'firebase'

import LogIn from './components/LogIn.vue'
import Settings from './components/Settings.vue'
import Users from './components/Users.vue'
import Submissions from './components/Submissions.vue'
import EditSubmission from './components/EditSubmission.vue'
import BitsStoreReport from './components/BitsStoreReport.vue'
import GiftSubBatches from './components/GiftSubBatches.vue'
import ActionCenter from './components/ActionCenter.vue'
import Mails from './components/Mails.vue'
import Rules from './components/Rules.vue'
import Lanes from './components/Lanes.vue'

Vue.use(VueRouter)

const router =  new VueRouter({
  mode: 'history',
  routes: [
    { path: '*', component: Users, meta: { requireAuth: true } },
    // { path: '/login', component: LogIn, alias: '/logout' },
    { path: '/settings', component: Settings, meta: { requireAuth: true } },
    { path: '/users', component: Users, meta: { requireAuth: true } },
    { path: '/users/:id', component: Users, props: true, meta: { requireAuth: true } },
    { path: '/report', component: BitsStoreReport, meta: { requireAuth: true } },
    { path: '/mails', component: Mails, meta: { requireAuth: true } },
    { path: '/lanes', component: Lanes, meta: { requireAuth: true } },
    { path: '/rules', component: Rules, meta: { requireAuth: true } },
    {
      path: '/submissions',
      component: Submissions,
      meta: { requireAuth: true }
    },
    {
      path: '/submissions/pending',
      component: Submissions,
      props: { defaultFilter: 'pending' },
      meta: { requireAuth: true }
    },
    {
      path: '/submissions/:id',
      component: EditSubmission,
      props: true,
      meta: { requireAuth: true }
    },
    {
      path: '/queue',
      component: Submissions,
      props: { queueMode: true },
      meta: { requireAuth: true }
    },
    {
      path: '/giftsubs',
      component: GiftSubBatches,
      meta: { requireAuth: true }
    },
    {
      path: '/action-center',
      component: ActionCenter,
      meta: { requireAuth: true }
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (
    Vue.init
    && to.matched.some(r => r.meta.requireAuth)
    && firebase.auth().currentUser === null
  ) {
    return next('/login')
  }
  next()
})

export default router
